import { createSlice } from "@reduxjs/toolkit";

export const vendorInvoiceFiltersSlice = createSlice({
    name: 'vendorInvoiceFilters',
    initialState: {
        searchVal: '',
        filters: {
            statusId: { value: null },
            parqVendorName: { value: null },
            hasErrors: { value: null },
        }
    },
    reducers: {
        setSearchVal: (state, action) => {
            state.searchVal = action.payload;
        },
        setFilters: (state, action) => {
            state.filters = action.payload;
        }
    },
});

export const { setSearchVal, setFilters } = vendorInvoiceFiltersSlice.actions;
export default vendorInvoiceFiltersSlice.reducer;
